const LLT_PENDING = 'llt_pending';
const LLT_FAILED = 'llt_failed';
const LLT_DOWNLOADED = 'llt_downloaded';

export {
  LLT_PENDING,
  LLT_FAILED,
  LLT_DOWNLOADED,
};



// WEBPACK FOOTER //
// ./src/store/longLocationDurations/types.js